module.exports = __webpack_public_path__ + "img/qy-jr.4a8b28cb.svg";